// data-testid registry for A Guy Who Hunts site.

export const NAV = {
	home: 'nav-home-link',
	season: 'nav-season-link',
	fieldNotes: 'nav-field-notes-link',
	recaps: 'nav-recaps-link',
	about: 'nav-about-link',
	newsletter: 'nav-newsletter-link',
	contact: 'nav-contact-link',
	gear: 'nav-gear-link',
	mobileToggle: 'nav-mobile-toggle',
	mobileSheet: 'nav-mobile-sheet',
	logo: 'nav-logo-link',
};

export const HERO = {
	primaryCta: 'hero-primary-cta',
	secondaryCta: 'hero-watch-youtube-button',
};

export const NEWSLETTER = {
	emailInput: 'newsletter-email-input',
	firstNameInput: 'newsletter-first-name-input',
	consentCheckbox: 'newsletter-consent-checkbox',
	submitButton: 'newsletter-submit-button',
	successMessage: 'newsletter-success-message',
	errorMessage: 'newsletter-error-message',
};

export const CONTACT = {
	nameInput: 'contact-name-input',
	emailInput: 'contact-email-input',
	reasonSelect: 'contact-reason-select',
	messageInput: 'contact-message-input',
	submitButton: 'contact-submit-button',
	successMessage: 'contact-success-message',
	errorMessage: 'contact-form-error-text',
};

export const SEASON = {
	filterAll: 'season-filter-all',
	filterButton: 'season-filter-button',
	card: 'season-entry-card',
	prev: 'season-detail-prev-link',
	next: 'season-detail-next-link',
};

export const FIELD_NOTES = {
	searchInput: 'field-notes-search-input',
	categorySelect: 'field-notes-category-select',
	card: 'field-note-card',
};

export const RECAPS = {
	listCard: 'recap-list-card',
	detailTitle: 'recap-detail-title',
	detailIntro: 'recap-detail-intro',
	noteRow: 'recap-detail-note',
	emptyState: 'recap-detail-empty',
};

export const ADMIN = {
	emailInput: 'admin-login-email-input',
	passwordInput: 'admin-login-password-input',
	submitButton: 'admin-login-submit-button',
	loginError: 'admin-login-error',
	logoutButton: 'admin-logout-button',
	seasonCreate: 'admin-season-create-button',
	seasonRow: 'admin-season-row',
	seasonEditor: 'admin-season-editor-form',
	seasonEditorSave: 'admin-season-editor-save',
	seasonEditorDelete: 'admin-season-editor-delete',
	noteCreate: 'admin-field-note-create-button',
	noteRow: 'admin-field-note-row',
	noteEditor: 'admin-field-note-editor-form',
	noteEditorSave: 'admin-field-note-editor-save',
	noteEditorDelete: 'admin-field-note-editor-delete',
	videoSave: 'admin-featured-video-save',
	configSave: 'admin-site-config-save',
	subscribersExport: 'admin-subscribers-export',
	inboxRow: 'admin-inbox-row',
	recapRow: 'admin-recap-row',
	recapEditIntro: 'admin-recap-edit-intro',
	recapPublishToggle: 'admin-recap-publish-toggle',
	recapSaveButton: 'admin-recap-save-button',
};
